// extracted by mini-css-extract-plugin
export var downArrow = "_9a-0";
export var label = "_9a-1";
export var treatmentCard = "_9a-3";
export var upArrow = "_9a-2";